import styled from '@emotion/styled';
import Icon from 'ui/images/attention.svg';
import { useNavigate } from 'react-router-dom';
import { mqUser } from 'utils/responsive';

interface IAttention {
    text: string;
    link: string;
}

const Wrapper = styled.div`
    border: 1px solid #fb0e0e;
    border-radius: 10px;
    padding: 12px 20px;
    gap: 5px;
    display: flex;
    align-items: center;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    ${mqUser('NARROW')} {
        margin-bottom: 0;
    }
`;

const AttentionIcon = styled.img`
    width: 23px;
    height: 23px;
`;

const Text = styled.div`
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0%;
    cursor: pointer;
    width: 100%;

    &:hover {
        text-decoration: underline;
    }
`;

const TextContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
`;

export const AttentionCard: React.FC<{ attentionList: IAttention[] }> = ({ attentionList }) => {
    const navigate = useNavigate();
    return (
        <Wrapper>
            {attentionList.map((attention, index) => (
                <TextContainer key={index}>
                    <AttentionIcon src={Icon} alt="attention" />

                    <Text onClick={() => navigate(attention.link)} key={index}>
                        {attention.text}
                    </Text>
                </TextContainer>
            ))}
        </Wrapper>
    );
};
